import { createFileRoute } from '@tanstack/react-router'
import { pageHead } from '../lib/seo'

export const Route = createFileRoute('/about')({
  head: () =>
    pageHead({
      path: '/about',
      title: 'About',
      description:
        'About HTML Editor — a free online WYSIWYG HTML editor that runs in your browser.'
    }),
  component: AboutPage
})

function AboutPage() {
  return (
    <article className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-bold mb-6">About HTML Editor</h1>
      <p className="mb-4 leading-relaxed">
        HTML Editor is a free, browser-based WYSIWYG editor that helps you write
        and refine clean, W3C-compliant HTML without installing anything or
        creating an account. You can compose content visually and copy the
        generated source straight into your project.
      </p>
      <p className="mb-4 leading-relaxed">
        The editor runs entirely in your browser. We do not store the content
        you create on our servers — it stays on your device while you work.
      </p>
      <h2 className="text-2xl font-semibold mt-8 mb-3">Who runs it</h2>
      <p className="mb-4 leading-relaxed">
        HTML Editor is operated by{' '}
        <a
          href="https://digitalrocketfactory.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#ff694a] underline hover:no-underline"
        >
          <strong>Digital Rocket Factory Oy</strong>
        </a>
        , a company registered in Finland. We build small, focused web tools
        and keep them free where we can.
      </p>
      <h2 className="text-2xl font-semibold mt-8 mb-3">Get in touch</h2>
      <p className="mb-4 leading-relaxed">
        Questions, bug reports, or feedback? Email{' '}
        <a
          href="mailto:support@htmleditor.io"
          className="text-[#ff694a] underline hover:no-underline"
        >
          support@htmleditor.io
        </a>
        .
      </p>
    </article>
  )
}
